import { getLowestPrice } from '@modules/price/parsers';
import { fireLinkTag } from './tagManager';

// Triggered if Order Swatches Button Is Visible
/**
 * @param {number} productId
 * @param {object} productPrice
 */
const tagOrderSwatchesPresent = (productId, productPrice) => {
  const event = {
    event_name: 'order free swatches present',
    product_id: productId,
    product_price: getLowestPrice(productPrice),
  };

  fireLinkTag(event);
};

// Triggered if Order Swatches Drawer is Opened
/**
 * @param {number} productId
 * @param {object} productPrice
 */
const tagOrderSwatchesClick = (productId, productPrice) => {
  const event = {
    event_name: 'order free swatches',
    product_id: productId,
    product_price: getLowestPrice(productPrice),
  };

  fireLinkTag(event);
};

// Triggered if Order Swatches Request is Completed
/**
 * @param {string} email
 * @param {string} productId
 * @param {object} productPrice
 */
const tagOrderSwatchesComplete = (email, productId, productPrice) => {
  const event = {
    customer_email: email,
    event_name: 'order free swatches complete',
    product_id: productId,
    product_price: getLowestPrice(productPrice),
  };

  fireLinkTag(event);
};

export {
  tagOrderSwatchesPresent,
  tagOrderSwatchesClick,
  tagOrderSwatchesComplete,
};
